<template>
  <img
    v-if="showFallback"
    v-bind="$attrs"
    :src="fallbackSrc"
    :alt="fallbackAlt"
  />
  <video
    v-else
    v-bind="$attrs"
    ref="videoRef"
    autoplay
    loop
    muted
    playsinline
    webkit-playsinline
    disablepictureinpicture
    aria-hidden="true"
    style="clip-path: inset(0 0 4px 0 round 0.75rem);"
    @error="onError"
  />
</template>

<script>
import { ref, computed, onMounted } from 'vue'

export default {
  name: 'LazyVideo',
  inheritAttrs: false,
  props: {
    src: { type: String, required: true },
    fallbackSrc: { type: String, required: true },
    fallbackAlt: { type: String, default: '' },
    rootMargin: { type: String, default: '200px 0px' },
  },
  setup(props) {
    const prefersReducedMotion = ref(
      typeof window !== 'undefined' && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    )
    const videoRef = ref(null)
    const videoError = ref(false)

    const showFallback = computed(() => prefersReducedMotion.value || videoError.value)

    function onError() {
      videoError.value = true
    }

    onMounted(() => {
      if (showFallback.value || !videoRef.value) return

      if (!('IntersectionObserver' in window)) {
        videoRef.value.src = props.src
        videoRef.value.load()
        return
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting && videoRef.value) {
            videoRef.value.src = props.src
            videoRef.value.load()
            observer.disconnect()
          }
        },
        { rootMargin: props.rootMargin }
      )
      observer.observe(videoRef.value)
    })

    return { showFallback, videoRef, onError }
  }
}
</script>

<style>
video::-webkit-media-controls,
video::-webkit-media-controls-enclosure,
video::-webkit-media-controls-panel {
  display: none !important;
}
</style>
